import { useEffect, useState } from 'react';

/**
 * Returns `false` during SSR and the initial hydration pass, `true` after mount.
 *
 * Use this to defer rendering of components that depend on client-only state
 * (localStorage, cookies not available on server, window APIs) so that the
 * server and client produce identical output on first render, avoiding
 * hydration mismatches (React error 418/423).
 */
const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

export default useHasMounted;
